import { render, staticRenderFns } from "./yuerbzuzhuang.vue?vue&type=template&id=73eb5567&scoped=true&"
import script from "./yuerbzuzhuang.vue?vue&type=script&lang=js&"
export * from "./yuerbzuzhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eb5567",
  null
  
)

export default component.exports